import CardTeam from "../base-components/CardTeam";
import Wave from "../base-components/Wave";
import { motion, LayoutGroup } from "motion/react"
import {useState} from "react";

function TeamSection({ headings, members, orientation, text }) {
    const isLeft = orientation === "left";
    const [activeMemberId, setActiveMemberId] = useState(null);

    return (
        <div>
            <div className={`
                    text-center -space-y-3 -mt-[3vw]
                    md:flex-1 ${isLeft ? "md:text-end" : "md:text-start"}
                    md:-space-y-6
                    lg:-space-y-10
                    xl:-space-y-12 
                    2xl:-space-y-14
            `}>
                {headings.map((heading, i) => (
                    <h2 key={i} className="
                                    font-[900] text-light text-[5.5vw]
                    ">
                        {heading}
                    </h2>
                ))}
            </div>
            <div className={`
                    flex flex-col-reverse items-center
                    md:items-stretch md:flex-row ${isLeft ? "md:-ml-5 md:space-x-[3vw]" : "md:flex-row-reverse md:justify-between md:gap-[4vw]"
            }
            `}>
                <div className="
                        flex flex-col
                        md:w-2/3
                ">
                    <div className={`
                            flex py-10
                            ${isLeft ? "" : "md:justify-end"}
                    `}>
                        <LayoutGroup>
                            {members.map((member, idx) => (
                                <motion.div
                                    key={member.id}
                                    layout
                                    initial={{ rotate: Number(member.rotation) }}
                                    animate={{
                                        rotate: Number(member.rotation),
                                        zIndex: activeMemberId === member.id ? 10 : 1,
                                    }}
                                    whileHover={{ scale: 1.05, zIndex: 10 }}
                                    whileTap={{ scale: 1.05 }}
                                    onTap={() => setActiveMemberId(prev => prev === member.id ? null : member.id)}
                                    transition={{
                                        layout: { type: "spring", stiffness: 500, damping: 35 },
                                        rotate: { type: "spring", stiffness: 500, damping: 35 },
                                    }}
                                >

                                <CardTeam
                                        name={member.name}
                                        image={member.image}
                                        shadowX={idx === 0 ? -8 : 8}
                                        shadowY={16}
                                    />
                                </motion.div>
                            ))}
                        </LayoutGroup>
                    </div>
                </div>
                <div className={`
                        flex 
                        ${isLeft ? "md:text-end" : ""} md:mt-24
                        lg:mt-40
                `}>
                    <p className={`
                                text-light text-[3vw] font-[400] text-center mt-[2vw]
                                md:mt-0 md:text-[2vw]
                                ${isLeft ? "md:text-right" : "md:text-left"}
                    `}>{text}</p>
                </div>
            </div>
            <div className="
                 mt-24
                 md:py-8 md:mt-0
            ">
                <Wave
                    svgFill="#f0f0f0"
                    pathStroke="white"
                    pathStrokeWidth={8}
                    pathFill="transparent"
                />
            </div>
        </div>
    );
}

export default TeamSection;
